<script setup>
import {ref} from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const Tab = ref([
    {
        tab_name:'首页',
        tab_path:'/shop/home'
    },
    {
        tab_name:'分类',
        tab_path:'/shop/category'
    },
    {
        tab_name:'购物车',
        tab_path:'/shop/cart'
    },
    {
        tab_name:'我的',
        tab_path:'/shop/profile'
    }
]);

function tab_route(tab_path){
    setTimeout(() => {
        router.push(tab_path)
    });
}
</script>

<template>
    <div class="tab_allcss">
        <div v-for="tab in Tab" :key="tab.tab_name">
            <span class="tab_eachcss" @click="tab_route(tab.tab_path)">{{tab.tab_name}}</span>
        </div>
    </div>
</template>

<style scoped>
.tab_allcss{
    position:fixed;
    display: flex;
    flex-direction: row;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    border-top: 1px solid #f0f0f0;
    height: 50px;
    align-items: center;
    justify-content: space-around;
}

.tab_eachcss{
    padding: 8px 16px;
    border-radius: 6px;
    color: #666;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
}

.tab_eachcss:hover {
    background-color: #9faffe;
    color: white;
}
</style>